import { bool, func, string, oneOfType, element } from 'prop-types'

const checked = bool
const disabled = bool
const onFocus = func
const label = oneOfType([string, element])

export { checked, disabled, onFocus, label }
